let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("fPDWC")).then(() => parcelRequire('35reh'));